import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

import store from "./store"
// import { PayPalScriptProvider } from "@paypal/react-paypal-js"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* <PayPalScriptProvider options={{
        "client-id": "AYDX1OhoEbIlJQ4YeBiK4dcavvr5D_dHkbxa3aLr3lMJx3oaMXj5W5SnRLGTCchTWLLrf3_LC57ZSVPJ",
        "currency": "EUR",
        components: "buttons",        // ou "hosted-buttons" si vous voulez vraiment héberger vos boutons PayPal
        // disableFunding: "venmo"
        disableFunding: "credit,card"
      }}> */}
      <App />
      {/* </PayPalScriptProvider> */}
    </BrowserRouter>
  </Provider>
)

serviceWorker.unregister()
